type Props = { flipped?: boolean; cowPrint?: boolean };

export default function CoiledCord({ flipped, cowPrint = false }: Props) {
  return (
    <div className="w-full overflow-hidden py-8" aria-hidden>
      <svg
        viewBox="0 0 1200 80"
        className={`w-full h-20 ${flipped ? "scale-y-[-1]" : ""}`}
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="cordGrad" x1="0" x2="1">
            <stop offset="0%" stopColor="#FF5E6C" />
            <stop offset="50%" stopColor="#E94BD6" />
            <stop offset="100%" stopColor="#FFD23F" />
          </linearGradient>
        </defs>
        <path
          d="M0 40 Q 30 0, 60 40 T 120 40 T 180 40 T 240 40 T 300 40 T 360 40 T 420 40 T 480 40 T 540 40 T 600 40 T 660 40 T 720 40 T 780 40 T 840 40 T 900 40 T 960 40 T 1020 40 T 1080 40 T 1140 40 T 1200 40"
          stroke="url(#cordGrad)"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
        />
        {cowPrint && (
          <g opacity="0.75">
            {/* cow-print blobs grazing along the cord */}
            <path d="M140 18 q 10 -8 20 0 q 8 8 -2 14 q -12 6 -20 -2 q -6 -6 2 -12" fill="#FCE8C8" />
            <circle cx="150" cy="25" r="3.5" fill="#1A1040" />
            <path d="M420 44 q 12 -6 20 2 q 6 8 -4 12 q -14 4 -20 -4 q -4 -6 4 -10" fill="#FCE8C8" opacity="0.8" />
            <circle cx="430" cy="51" r="3" fill="#1A1040" />
            <path d="M700 14 q 10 -8 18 -2 q 8 8 0 14 q -12 6 -18 0 q -6 -6 0 -12" fill="#FCE8C8" />
            <circle cx="709" cy="21" r="3.5" fill="#1A1040" />
            <path d="M980 44 q 12 -6 20 0 q 6 10 -6 14 q -12 2 -18 -4 q -4 -6 4 -10" fill="#FCE8C8" opacity="0.8" />
            <circle cx="990" cy="51" r="3" fill="#1A1040" />
          </g>
        )}
      </svg>
    </div>
  );
}
